module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nconst renderMode = ((storage || {}).request || {}).renderMode || ''\n// load different bundles according to loaded route\nconst routeConfig \t\t= ((storage.request || {}).route || {}).config || {}\nconst isOffer\t\t\t= routeConfig.isOffer || false\nconst isConfirmation\t= routeConfig.isConfirmation || false\nconst isDriveOrder\t\t= routeConfig.isDriveOrder || false\nconst isInvoice\t\t\t= routeConfig.isInvoice || false\n// define page title for pdf-saas\nlet title = '';\nmodel.meta = model.meta || {}\n// TODO: POIAAA title\nconst tripAttributes = (((storage.request || {}).trip || {}).data || {}).attributes || {}\nif(tripAttributes.tripID){\nlet documentType = '???'\nif(isOffer) \t\t\tdocumentType = 'offer';\nelse if(isConfirmation) documentType = 'confirmation';\nelse if(isDriveOrder) \tdocumentType = 'driveOrder';\nelse if(isInvoice) \t\tdocumentType = 'invoice';\ntitle = storage.__(`document.${documentType}.documentTitle`, {\ntripID: \ttripAttributes.tripID,\ntitle: \t\ttripAttributes.title || '',\ntripStart: \ttripAttributes.tripStart ? utils.moment(tripAttributes.tripStart).format('DD.MM.YYYY') : '',\n})\n}\nif(!title){\ntitle = model.meta.title || model.name || model.nameSEO || storage.__(\"error:unknownPageTitle\")\n}\nmodel.meta.title = title\nconst bodyClasses = []\nif(model.bodyClass) \t\t\t\tbodyClasses.push(model.bodyClass);\nif(environment.style) \t\t\t\tbodyClasses.push(environment.style);\nif((environment.device || {}).type) bodyClasses.push(`device-${environment.device.type}`);\nif(environment.breakPoint) \t\t\tbodyClasses.push(`breakPoint-${environment.breakPoint}`);\nif(isOffer)\t\t\tbodyClasses.push('isOffer');\nif(isConfirmation)\tbodyClasses.push('isConfirmation');\nif(isDriveOrder)\tbodyClasses.push('isDriveOrder');\nif(isInvoice)\t\tbodyClasses.push('isInvoice');\n// TODO: i would love to use the strict mode via doctype (<!doctype html>), but only if one finds a solution for the:\n//  \t\t.base_form_fields_autoComplete .optionList margin-bottom: 100% during strict mode problem.\n%><!doctype html>\n<html lang=\"<%= model.lang %>\">\n<head>\n<!-- meta tags -->\n<title><%= title %></title>\n<%\n// TODO: POIAAA\n%>\n<meta name=\"HandheldFriendly\" content=\"True\">\n<meta name=\"MobileOptimized\" content=\"360\"/>\n<meta name=\"viewport\" content=\"user-scalable=no,initial-scale=1.0, minimum-scale=1.0,maximum-scale=1.0\">\n<% utils.forEach(model.meta, function(metaContent, metaName){ %>\n<meta name=\"<%= metaName %>\" content=\"<%= metaContent %>\" />\n<% }); %>\n<!-- favicons -->\n<link rel=\"apple-touch-icon\" sizes=\"57x57\" href=\"/favicon/apple-icon-57x57.png\">\n<link rel=\"apple-touch-icon\" sizes=\"60x60\" href=\"/favicon/apple-icon-60x60.png\">\n<link rel=\"apple-touch-icon\" sizes=\"72x72\" href=\"/favicon/apple-icon-72x72.png\">\n<link rel=\"apple-touch-icon\" sizes=\"76x76\" href=\"/favicon/apple-icon-76x76.png\">\n<link rel=\"apple-touch-icon\" sizes=\"114x114\" href=\"/favicon/apple-icon-114x114.png\">\n<link rel=\"apple-touch-icon\" sizes=\"120x120\" href=\"/favicon/apple-icon-120x120.png\">\n<link rel=\"apple-touch-icon\" sizes=\"144x144\" href=\"/favicon/apple-icon-144x144.png\">\n<link rel=\"apple-touch-icon\" sizes=\"152x152\" href=\"/favicon/apple-icon-152x152.png\">\n<link rel=\"apple-touch-icon\" sizes=\"180x180\" href=\"/favicon/apple-icon-180x180.png\">\n<link rel=\"icon\" type=\"image/png\" sizes=\"192x192\"  href=\"/favicon/android-icon-192x192.png\">\n<link rel=\"icon\" type=\"image/png\" sizes=\"32x32\" href=\"/favicon/favicon-32x32.png\">\n<link rel=\"icon\" type=\"image/png\" sizes=\"96x96\" href=\"/favicon/favicon-96x96.png\">\n<link rel=\"icon\" type=\"image/png\" sizes=\"16x16\" href=\"/favicon/favicon-16x16.png\">\n<link rel=\"manifest\" href=\"/favicon/manifest.json\">\n<meta name=\"msapplication-TileColor\" content=\"#ffffff\">\n<meta name=\"msapplication-TileImage\" content=\"/favicon/ms-icon-144x144.png\">\n<meta name=\"theme-color\" content=\"#ffffff\">\n<!-- css sources -->\n<%\n// renderMode === html => get html for the corresponding pdf file.\n// the pdf creator does not use stylesheets via link\nif(renderMode === 'html'){\n%>\n<link type=\"text/css\" rel=\"stylesheet\" href=\"/webpack/css/appDocumentPDF.css?usTS=<%- model.upStartTimestamp || '-' %>\" />\n<%\n} else {\n%>\n<link type=\"text/css\" rel=\"stylesheet\" href=\"/webpack/css/vendors~app~appDocument.css?usTS=<%- model.upStartTimestamp || '-' %>\" />\n<link type=\"text/css\" rel=\"stylesheet\" href=\"/webpack/css/vendors~style.css?usTS=<%- model.upStartTimestamp || '-' %>\" />\n<link type=\"text/css\" rel=\"stylesheet\" href=\"/webpack/css/style.css?usTS=<%- model.upStartTimestamp || '-' %>\" />\n<link type=\"text/css\" rel=\"stylesheet\" href=\"/webpack/css/appDocument.css?usTS=<%- model.upStartTimestamp || '-' %>\" />\n<%\n}\n%>\n</head>\n<body class=\"<%- bodyClasses.join(' ') %>\">\n<!-- sections -->\n<div class=\"appContainer\">\n<% if(tripAttributes.tripID){ %>\n<%- helpers.renderSection('status'); %>\n<%- helpers.renderSection('main'); %>\n<% } else { %>\n<h1><%= storage.__('error:404.document-not-found') %></h1>\n<% } %>\n</div>\n<%\n// renderMode === html => get html for the corresponding pdf file.\nif(renderMode !== 'html'){\n%>\n<!-- js server sources -->\n<script type=\"application/javascript\" class=\"dynamicJSSources\">\nglobalThis.route \t\t\t\t= \"<%= model.route || '' %>\";\nglobalThis.tree \t\t\t\t= <%- model.tree || 'null' %>;\nglobalThis.globalActionsByScope = <%- model.globalActionsByScope || 'null' %>;\nglobalThis.updateClientStorage \t= <%- model.updateClientStorage || 'null' %>;\nglobalThis.routeParams \t\t\t= <%- model.routeParams || {} %>;\n</script>\n<!-- js sources -->\n<script type=\"text/javascript\" src=\"/webpack/js/vendors~app~appDocument.js?usTS=<%- model.upStartTimestamp || '-' %>\"></script>\n<script type=\"text/javascript\" src=\"/webpack/js/appDocumentPDF.js?usTS=<%- model.upStartTimestamp || '-' %>\"></script>\n<!--\t\t\t<script type=\"text/javascript\" src=\"/webpack/js/vendors~style.js?usTS=<%- model.upStartTimestamp || '-' %>\"></script>-->\n<!--\t\t\t<script type=\"text/javascript\" src=\"/webpack/js/style.js?usTS=<%- model.upStartTimestamp || '-' %>\"></script>-->\n<script type=\"text/javascript\" src=\"/webpack/js/appDocument.js?usTS=<%- model.upStartTimestamp || '-' %>\"></script>\n<%\n}\n%>\n</body>\n</html>"
  , __filename = "components/layouts/document.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
const renderMode = ((storage || {}).request || {}).renderMode || ''
// load different bundles according to loaded route
const routeConfig 		= ((storage.request || {}).route || {}).config || {}
const isOffer			= routeConfig.isOffer || false
const isConfirmation	= routeConfig.isConfirmation || false
const isDriveOrder		= routeConfig.isDriveOrder || false
const isInvoice			= routeConfig.isInvoice || false
// define page title for pdf-saas
let title = '';
model.meta = model.meta || {}
// TODO: POIAAA title
const tripAttributes = (((storage.request || {}).trip || {}).data || {}).attributes || {}
if(tripAttributes.tripID){
let documentType = '???'
if(isOffer) 			documentType = 'offer';
else if(isConfirmation) documentType = 'confirmation';
else if(isDriveOrder) 	documentType = 'driveOrder';
else if(isInvoice) 		documentType = 'invoice';
title = storage.__(`document.${documentType}.documentTitle`, {
tripID: 	tripAttributes.tripID,
title: 		tripAttributes.title || '',
tripStart: 	tripAttributes.tripStart ? utils.moment(tripAttributes.tripStart).format('DD.MM.YYYY') : '',
})
}
if(!title){
title = model.meta.title || model.name || model.nameSEO || storage.__("error:unknownPageTitle")
}
model.meta.title = title
const bodyClasses = []
if(model.bodyClass) 				bodyClasses.push(model.bodyClass);
if(environment.style) 				bodyClasses.push(environment.style);
if((environment.device || {}).type) bodyClasses.push(`device-${environment.device.type}`);
if(environment.breakPoint) 			bodyClasses.push(`breakPoint-${environment.breakPoint}`);
if(isOffer)			bodyClasses.push('isOffer');
if(isConfirmation)	bodyClasses.push('isConfirmation');
if(isDriveOrder)	bodyClasses.push('isDriveOrder');
if(isInvoice)		bodyClasses.push('isInvoice');
// TODO: i would love to use the strict mode via doctype (<!doctype html>), but only if one finds a solution for the:
//  		.base_form_fields_autoComplete .optionList margin-bottom: 100% during strict mode problem.

    ; __line = 41
    ; __append("<!doctype html>\n<html lang=\"")
    ; __line = 42
    ; __append(escapeFn( model.lang ))
    ; __append("\">\n<head>\n<!-- meta tags -->\n<title>")
    ; __line = 45
    ; __append(escapeFn( title ))
    ; __append("</title>\n")
    ; __line = 46
    ; 
// TODO: POIAAA

    ; __line = 48
    ; __append("\n<meta name=\"HandheldFriendly\" content=\"True\">\n<meta name=\"MobileOptimized\" content=\"360\"/>\n<meta name=\"viewport\" content=\"user-scalable=no,initial-scale=1.0, minimum-scale=1.0,maximum-scale=1.0\">\n")
    ; __line = 52
    ;  utils.forEach(model.meta, function(metaContent, metaName){ 
    ; __append("\n<meta name=\"")
    ; __line = 53
    ; __append(escapeFn( metaName ))
    ; __append("\" content=\"")
    ; __append(escapeFn( metaContent ))
    ; __append("\" />\n")
    ; __line = 54
    ;  }); 
    ; __append("\n<!-- favicons -->\n<link rel=\"apple-touch-icon\" sizes=\"57x57\" href=\"/favicon/apple-icon-57x57.png\">\n<link rel=\"apple-touch-icon\" sizes=\"60x60\" href=\"/favicon/apple-icon-60x60.png\">\n<link rel=\"apple-touch-icon\" sizes=\"72x72\" href=\"/favicon/apple-icon-72x72.png\">\n<link rel=\"apple-touch-icon\" sizes=\"76x76\" href=\"/favicon/apple-icon-76x76.png\">\n<link rel=\"apple-touch-icon\" sizes=\"114x114\" href=\"/favicon/apple-icon-114x114.png\">\n<link rel=\"apple-touch-icon\" sizes=\"120x120\" href=\"/favicon/apple-icon-120x120.png\">\n<link rel=\"apple-touch-icon\" sizes=\"144x144\" href=\"/favicon/apple-icon-144x144.png\">\n<link rel=\"apple-touch-icon\" sizes=\"152x152\" href=\"/favicon/apple-icon-152x152.png\">\n<link rel=\"apple-touch-icon\" sizes=\"180x180\" href=\"/favicon/apple-icon-180x180.png\">\n<link rel=\"icon\" type=\"image/png\" sizes=\"192x192\"  href=\"/favicon/android-icon-192x192.png\">\n<link rel=\"icon\" type=\"image/png\" sizes=\"32x32\" href=\"/favicon/favicon-32x32.png\">\n<link rel=\"icon\" type=\"image/png\" sizes=\"96x96\" href=\"/favicon/favicon-96x96.png\">\n<link rel=\"icon\" type=\"image/png\" sizes=\"16x16\" href=\"/favicon/favicon-16x16.png\">\n<link rel=\"manifest\" href=\"/favicon/manifest.json\">\n<meta name=\"msapplication-TileColor\" content=\"#ffffff\">\n<meta name=\"msapplication-TileImage\" content=\"/favicon/ms-icon-144x144.png\">\n<meta name=\"theme-color\" content=\"#ffffff\">\n<!-- css sources -->\n")
    ; __line = 74
    ; 
// renderMode === html => get html for the corresponding pdf file.
// the pdf creator does not use stylesheets via link
if(renderMode === 'html'){

    ; __line = 78
    ; __append("\n<link type=\"text/css\" rel=\"stylesheet\" href=\"/webpack/css/appDocumentPDF.css?usTS=")
    ; __line = 79
    ; __append( model.upStartTimestamp || '-' )
    ; __append("\" />\n")
    ; __line = 80
    ; 
} else {

    ; __line = 82
    ; __append("\n<link type=\"text/css\" rel=\"stylesheet\" href=\"/webpack/css/vendors~app~appDocument.css?usTS=")
    ; __line = 83
    ; __append( model.upStartTimestamp || '-' )
    ; __append("\" />\n<link type=\"text/css\" rel=\"stylesheet\" href=\"/webpack/css/vendors~style.css?usTS=")
    ; __line = 84
    ; __append( model.upStartTimestamp || '-' )
    ; __append("\" />\n<link type=\"text/css\" rel=\"stylesheet\" href=\"/webpack/css/style.css?usTS=")
    ; __line = 85
    ; __append( model.upStartTimestamp || '-' )
    ; __append("\" />\n<link type=\"text/css\" rel=\"stylesheet\" href=\"/webpack/css/appDocument.css?usTS=")
    ; __line = 86
    ; __append( model.upStartTimestamp || '-' )
    ; __append("\" />\n")
    ; __line = 87
    ; 
}

    ; __line = 89
    ; __append("\n</head>\n<body class=\"")
    ; __line = 91
    ; __append( bodyClasses.join(' ') )
    ; __append("\">\n<!-- sections -->\n<div class=\"appContainer\">\n")
    ; __line = 94
    ;  if(tripAttributes.tripID){ 
    ; __append("\n")
    ; __line = 95
    ; __append( helpers.renderSection('status') )
    ; __append("\n")
    ; __line = 96
    ; __append( helpers.renderSection('main') )
    ; __append("\n")
    ; __line = 97
    ;  } else { 
    ; __append("\n<h1>")
    ; __line = 98
    ; __append(escapeFn( storage.__('error:404.document-not-found') ))
    ; __append("</h1>\n")
    ; __line = 99
    ;  } 
    ; __append("\n</div>\n")
    ; __line = 101
    ; 
// renderMode === html => get html for the corresponding pdf file.
if(renderMode !== 'html'){

    ; __line = 104
    ; __append("\n<!-- js server sources -->\n<script type=\"application/javascript\" class=\"dynamicJSSources\">\nglobalThis.route 				= \"")
    ; __line = 107
    ; __append(escapeFn( model.route || '' ))
    ; __append("\";\nglobalThis.tree 				= ")
    ; __line = 108
    ; __append( model.tree || 'null' )
    ; __append(";\nglobalThis.globalActionsByScope = ")
    ; __line = 109
    ; __append( model.globalActionsByScope || 'null' )
    ; __append(";\nglobalThis.updateClientStorage 	= ")
    ; __line = 110
    ; __append( model.updateClientStorage || 'null' )
    ; __append(";\nglobalThis.routeParams 			= ")
    ; __line = 111
    ; __append( model.routeParams || {} )
    ; __append(";\n</script>\n<!-- js sources -->\n<script type=\"text/javascript\" src=\"/webpack/js/vendors~app~appDocument.js?usTS=")
    ; __line = 114
    ; __append( model.upStartTimestamp || '-' )
    ; __append("\"></script>\n<script type=\"text/javascript\" src=\"/webpack/js/appDocumentPDF.js?usTS=")
    ; __line = 115
    ; __append( model.upStartTimestamp || '-' )
    ; __append("\"></script>\n<!--			<script type=\"text/javascript\" src=\"/webpack/js/vendors~style.js?usTS=")
    ; __line = 116
    ; __append( model.upStartTimestamp || '-' )
    ; __append("\"></script>-->\n<!--			<script type=\"text/javascript\" src=\"/webpack/js/style.js?usTS=")
    ; __line = 117
    ; __append( model.upStartTimestamp || '-' )
    ; __append("\"></script>-->\n<script type=\"text/javascript\" src=\"/webpack/js/appDocument.js?usTS=")
    ; __line = 118
    ; __append( model.upStartTimestamp || '-' )
    ; __append("\"></script>\n")
    ; __line = 119
    ; 
}

    ; __line = 121
    ; __append("\n</body>\n</html>")
    ; __line = 123
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/layouts/document.ejs

}